<template>
  <q-btn
    no-caps
    class="btn-save q-my-sm full-width"
    @click="visible = true"
    :label="$t('label.rich_menu_template')"
  />
  <q-dialog v-model="visible" full-height position="right">
    <q-card class="column" style="width: 1700px; max-width: 90vw;">
      <q-toolbar class="auto-height horizontal-line">
        <q-toolbar-title class="q-pa-sm">{{ $t('label.rich_menu_template') }}</q-toolbar-title>
        <q-btn flat round dense icon="close" @click="onCancel" />
      </q-toolbar>
      <q-card-section class="col horizontal-line">
        <CLoading :loading="loading" />
        <q-splitter v-model="splitterModel" :limits="[20, 20]" style="height: 100%">
          <template v-slot:before>
            <TemplateSelector
              :selected-template="selectedTemplate"
              :selected-template-compact="selectedTemplateCompact"
              :rich-menu-content="richMenuContent"
              :visible="visible"
              @on-select-template="selectTemplate"
            ></TemplateSelector>
          </template>

          <template v-slot:after>
            <TemplateSettingForm
              ref="templateSettingForm"
              :selected-template-compact="selectedTemplateCompact"
              :visible="visible"
              @on-submit-template="submitTemplate"
            ></TemplateSettingForm>
          </template>
        </q-splitter>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn no-caps class="btn-cancel" @click="onCancel">{{ $t('cancel') }}</q-btn>
        <q-btn no-caps class="btn-save" @click="mergeImages">{{ $t('next') }}</q-btn>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { IRichMenuTemplate, IRichMenuTemplateCompact, IRichMenuContent } from '@/utils/types'
import { Prop } from 'vue-property-decorator'
import CLoading from '@/components/common/ui/CLoading.vue'
import MediaUploader from '@/components/media-manager/MediaUploader.vue'
import TemplateSelector from '@/components/rich-menus/selectors/TemplateSelector.vue'
import TemplateSettingForm from '@/components/rich-menus/selectors/TemplateSettingForm.vue'

@Options({
  components: { TemplateSettingForm, TemplateSelector, MediaUploader, CLoading },
  directives: { maska },
  emits: ['onSubmitTemplate'],
})
export default class RichMenuTemplate extends Vue {
  @Prop()
  selectedTemplateCompact!: IRichMenuTemplateCompact

  @Prop()
  richMenuContent!: IRichMenuContent

  loading = false
  visible = false
  splitterModel = 20

  selectedTemplate: IRichMenuTemplate = {}

  onCancel() {
    this.$refs.templateSettingForm.resetAll()
    this.visible = false
  }

  async selectTemplate(item) {
    this.selectedTemplate = item
    this.$refs.templateSettingForm.onTemplateSelected(item)
  }

  async mergeImages() {
    this.loading = true
    this.$refs.templateSettingForm.mergeImages()
  }

  async submitTemplate(template) {
    this.$emit('onSubmitTemplate', template)
    this.loading = false
    this.onCancel()
  }
}
</script>

<style lang="scss" scoped>
.template-container {
  width: 700px;
  min-height: 200px;
  position: relative;
}
.target {
  position: absolute;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  border: 1px dashed #44aaff;
  white-space: nowrap;
  background-repeat: no-repeat;
  cursor: pointer;
  background-size: cover;
}
.target.active {
  border: 2px solid #0048ff !important;
}
</style>
